"use strict";
exports.__esModule = true;
exports.ServerErrors = void 0;
var ServerErrors;
(function (ServerErrors) {
    ServerErrors["BAD_REQUEST"] = "Bad request, UID not present in request";
    ServerErrors["BAD_REQUEST_PARAM"] = "Bad request, UID or required params not available";
    ServerErrors["NOT_AUTHORIZED"] = "You are not authorized to do this action";
})(ServerErrors = exports.ServerErrors || (exports.ServerErrors = {}));
